import React from 'react';
import { ToastContainer } from 'react-toastify';
import UserManualPage from '../components/UserManualPage';

const UserManualApp = (props) => (
  <>
    <UserManualPage sections={props.sections} adminDraftsEnabled={props.admin_drafts_enabled} />
    <ToastContainer icon={false} />
  </>
);

export default UserManualApp;
